import MythicLogo from '../assets/logos/Mythic_Logo.png';
import JapaneseLogo from '../assets/logos/Japanese_Logo.png';
import AztecCodexLogo from '../assets/logos/Aztec_Codex_Logo.png';
import UrbanViceLogo from '../assets/logos/Urban_Vice_Logo.png';
import ClassicRTSLogo from '../assets/logos/Classic_RTS_Logo.png';
import TourDeFrance80sLogo from '../assets/logos/80ies_TdF_Logo.png';
import ModernVueltaLogo from '../assets/logos/Modern_Vuelta_Logo.png';
import AboriginalSonglineLogo from '../assets/logos/Aboriginal_Songline_Logo.png';
import CaravanAtlasLogo from '../assets/logos/Caravan_Atlas_Logo.png';
import WinterWonderlandLogo from '../assets/logos/Winter Wonderland Logo.png';
import ChroniclesLogo from '../assets/logos/Chronicles, Mythic Maps Logo.png';
import HolographicProjectionLogo from '../assets/logos/Holographic Projection Logo.png';
import Happy2026Logo from '../assets/logos/Happy 2026, Logo.png';

export const LOGO_FALLBACK = {
  'Mythic': MythicLogo,
  'Japanese': JapaneseLogo,
  'Urban Vice': UrbanViceLogo,
  'Classic RTS': ClassicRTSLogo,
  '80ies Tour de France': TourDeFrance80sLogo,
  'Modern Vuelta': ModernVueltaLogo,
  'Caravan Atlas': CaravanAtlasLogo,
  'Aboriginal Songline': AboriginalSonglineLogo,
  'Aztec Codex': AztecCodexLogo,
  'Winter Wonderland': WinterWonderlandLogo,
  'Chronicles': ChroniclesLogo,
  'Holographic Projection': HolographicProjectionLogo,
  'Happy 2026': Happy2026Logo
};

export const getLogoForStyle = (styleName, logoUrl) => {
  if (logoUrl) return logoUrl;
  if (LOGO_FALLBACK[styleName]) return LOGO_FALLBACK[styleName];
  for (const [key, logo] of Object.entries(LOGO_FALLBACK)) {
    if (styleName.includes(key)) return logo;
  }
  return null;
};
